import { createContext, useContext, useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import AppLayout from './components/containers/AppLayout';
import LoadingContainer from './components/containers/LoadingContainer';
import ThemeWrapper from './components/containers/ThemeWrapper';
import api from './config/axios';
import { AppRoutes, AuthRoutes, WorkerRoutes } from './config/routes';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ScrollToTop from './utilities/ScrollToTop';

const UserContext = createContext({ user: null, setUser: () => {} });

function App() {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = () =>
        api.get('/auth/admin-access').then((res) => {
            setUser(res.data);
        });

    const verifyUser = () => {
        setLoading(true);
        refresh()
            .catch(() => setUser(null))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        verifyUser();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    console.log(user);
    return (
        <ThemeWrapper>
            <LoadingContainer loading={loading} full>
                <UserContext.Provider value={{ user, setUser, refresh }}>
                    <Router>
                        <ScrollToTop />
                        {user ? (
                            <>
                                {user.role === 'admin' ? (
                                    <Routes>
                                        <Route element={<AppLayout />}>
                                            <Route path="*" element={<AppRoutes />} />
                                        </Route>
                                    </Routes>
                                ) : (
                                    <Routes>
                                        <Route element={<AppLayout />}>
                                            <Route path="*" element={<WorkerRoutes />} />
                                        </Route>
                                    </Routes>
                                )}
                            </>
                        ) : (
                            <Routes>
                                <Route path="*" element={<AuthRoutes />} />
                            </Routes>
                        )}
                    </Router>
                </UserContext.Provider>
            </LoadingContainer>
            <ToastContainer position="top-center" hideProgressBar draggable={false} theme="colored" />
        </ThemeWrapper>
    );
}

const useUserContext = () => {
    return useContext(UserContext);
};

export { useUserContext };

export default App;
